import { EmailTemplateLanguageType } from "./EmailTemplate";

// The pages are listed on the server (LegalPageKeyEnum); the admin panel edits their texts
export type LegalPageKey = "referral-terms" | "terms-and-conditions" | "privacy-policy";

export type LegalPageLanguageType = EmailTemplateLanguageType;

export interface ILegalPageListItem {
  key: LegalPageKey;
  // Languages the page has a text in
  languages: LegalPageLanguageType[];
  updatedAt: string | null;
}

// Name in the admin panel and address on the site
export const LEGAL_PAGES: Record<LegalPageKey, { labelKey: string; sitePath: string }> = {
  "referral-terms": {
    labelKey: "ReferralProgramTerms",
    sitePath: "/referral-terms-and-conditions",
  },
  "terms-and-conditions": { labelKey: "TermsAndConditions", sitePath: "/terms-and-conditions" },
  "privacy-policy": { labelKey: "PrivacyPolicy", sitePath: "/privacy-policy" },
};
